import { render, staticRenderFns } from "./Records.vue?vue&type=template&id=89da760c&scoped=true"
import script from "./Records.vue?vue&type=script&lang=js"
export * from "./Records.vue?vue&type=script&lang=js"
import style0 from "./Records.vue?vue&type=style&index=0&id=89da760c&prod&lang=css"
import style1 from "./Records.vue?vue&type=style&index=1&id=89da760c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89da760c",
  null
  
)

/* custom blocks */
import block0 from "./Records.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports